import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [],
  modifiers: [
    {
      title: 'sm',
      isDefault: true
    },
    'md',
    'xs',
    'inverse'
  ],
  states: []
}

export default function Subtitle(props) {
  const { children, tag, inverse, xs, sm, md, ...rest } = props
  const CustomTag = tag || 'h2'

  return (
    <CustomTag {...rest} className={resolveProps(props, config, 'Subtitle')}>
      {children}
    </CustomTag>
  )
}

Subtitle.propTypes = {
  inverse: PropTypes.bool,
  tag: PropTypes.bool,
  children: PropTypes.node,
  xs: PropTypes.bool,
  sm: PropTypes.bool,
  md: PropTypes.bool
}
